/**
 * Created by matheusmorett on 16/08/17.
 */
import React, { Component } from 'react';
import './Dropdown.scss';

class Dropdown extends Component {

    static defaultProps = {
        items: [],
        onClick: undefined,
        onClose: undefined,
        onClickItem: () => { },
        open: undefined,
        selectedValue: ''
    };

    constructor(props) {
        super(props);
        this.state = { open: false }
        this.onClose = props.onClose !== undefined ? props.onClose : this.handleClose.bind(this)
        this.onOpen = props.onClick !== undefined ? props.onClick : this.handleOpen.bind(this)
        this.onClickItem = this.onClickItem.bind(this)
    }

    handleOpen = () => this.setState({ open: true })
    handleClose = () => this.setState({ open: false })

    onClose() {
        document.body.classList.remove('disable-scroll')
        this.props.onClose()
    }
    
    onOpen() {
        document.body.classList.add('disable-scroll')
        this.props.onClick()
    }

    onClickItem(e) {
        this.props.onClickItem(e)
        this.onClose()
    }

    render() {
        const open = this.props.open !== undefined ? this.props.open : this.state.open;
        return (
            <div className="Dropdown">
                <div className={`dropdown-backdrop ${open ? '' : 'closed'}`} onClick={() => this.onClose()}></div>
                <div className='dropdown-value' onClick={() => (this.props.items.length > 1) ? this.onOpen() : ''}>
                    {this.props.selectedValue}
                    {(this.props.items.length > 1 && <div className='icon-dropdown' style={{ color: '#f50673' }}>
                        <i className={open ? `icon icon-arrow-up` : `icon icon-arrow-down`} />
                    </div>)}
                </div>
                <List
                    onClickItem={this.onClickItem}
                    items={this.props.items}
                    showing={open} />
            </div>
        )
    }
}

const List = ({ items, onClickItem, showing }) => (
    <div className={`list-dropdown ${showing ? '' : 'closed'}`}>
        {items.map((item, index) => (
            <div key={index} className="item" onClick={() => onClickItem(item)}>
                {item.name}
            </div>
        ))}
    </div>
);

export default Dropdown